var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-drawer',{attrs:{"wrapClassName":"ak-drawer-empty-wrap","width":_vm.width,"visible":_vm.visible,"title":_vm.title,"closable":true,"afterVisibleChange":_vm.onClosed,"destroyOnClose":""},on:{"close":_vm.onHideModal}},[_vm._v(" 内容 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }